import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import apiInstance from './apiInstance';
import { connect } from 'react-redux';

class Catalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widgets: [],
      searchQuery: '',
      error: '',
      selectedCategory: '',
      sortOrder: '',
    };
  }

  componentDidMount() {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const widgetId = params.get('widgetId');
    if(widgetId){
      apiInstance.delete(`/widget/${widgetId}`)
      .then(response => {
        console.log(response)
        
      })
      .catch(error => {
          console.error('Error deleting the widget:', error);
      });
    }
   
    const urlWithoutParams = (window.location.href).split('?')[0];
    window.history.pushState({}, 'title', urlWithoutParams)
  }

  updateErrorMessage = (error = "", msg = "") => {
    this.setState((prevState) => {
        return ({
            ...prevState,
            error: error,
            msg: msg
        })
    })
}

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  render() {
    const { searchQuery, error } = this.state;

    const widgets = (this.props.widgetTypes)
    let filteredWidgets = widgets.filter(widget =>
      widget.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      widget.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (widget.desc ? widget.desc.toLowerCase().includes(searchQuery.toLowerCase()) : '')
    );
    
    if (this.state.selectedCategory) {
      filteredWidgets = filteredWidgets.filter(widget => widget.category === this.state.selectedCategory);
    }
    
    if (this.state.sortOrder === 'lowToHigh') {
      filteredWidgets = filteredWidgets.sort((a, b) => a.price - b.price);
    } else if (this.state.sortOrder === 'highToLow') {
      filteredWidgets = filteredWidgets.sort((a, b) => b.price - a.price);
    }
    
    function getWidgetSrc(imageSrc,name,type){
      if (imageSrc) {
        return imageSrc.startsWith("devadmin")
          ? `${process.env.REACT_APP_SERVER_URL}/${imageSrc}?ts=${Date.now()}`
          : `${imageSrc}?ts=${Date.now()}`;
      }
      return `/images/${name}-${type}.png`;
    };

    return (
      <div className="mjwi-ct-container">
        <div className="mjwi-ct-content">
          <div className="mjwi-promo-banner">
            <h1>Premium Widget Library</h1>
            <h3>Browse through our extensive collection of powerful, fully customizable & mobile-friendly widgets.</h3>
          </div>
          <div  className="mjwi-ct-search ">
            <input
              type="text"
              id="searchInput"
              value={searchQuery}
              placeholder="What are you looking for?"
              onChange={this.handleSearchChange}
            />
            <div className="mjwidev-input-field custom-select-wrapper mjwidev-width-40 mjwi-filter-gap">
                <select
                  value={this.state.selectedCategory}
                  onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                  className="mjwi-dropdown"
                >
                  <option value="">All Categories</option>
                  {[...new Set(widgets.map(widget => widget.category))].map(category => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
                <div className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z" />
              </svg>
            </div>
            </div>
            <div  className="mjwidev-input-field custom-select-wrapper mjwidev-width-40 mjwi-filter-gap">
               <select
                  value={this.state.sortOrder}
                  onChange={(e) => this.setState({ sortOrder: e.target.value })}
                  className="mjwi-dropdown"
                >
                  <option value="">Sort By</option>
                  <option value="lowToHigh">Price: Low to High</option>
                  <option value="highToLow">Price: High to Low</option>
                </select>
                <div className="custom-arrow mjwidev-top-30">
              <svg
                fill="#ffffff"
                height="16px"
                width="16px"
                viewBox="0 0 330 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z" />
              </svg>
            </div>
            </div>
 
          </div>
          <div className="mjwi-ct-list mjwi-row">
            {filteredWidgets.map(widget => (
              
              <Link to={`/editor?widgetType=${widget.id}`} key={widget.id} className="mjwi-ct-card">
                  <div className="mjwi-ct-card-banner">
                    <img 
                        src={ getWidgetSrc(widget.bannerImage,widget.name,"banner")} className="mjwi-catalog-banner" 
                        onError={(e) => {
                            if (!e.target.src.includes("Default-Widget-Thumb.png")) {
                                e.target.onerror = null;
                                e.target.src = "/images/Default-Widget-Thumb.png";
                            }
                        }}
                        alt="Widget Banner"
                    />
                </div>
                <div className="mjwi-ct-card-logoname">
                    <img 
                        src={getWidgetSrc(widget.iconImage,widget.name,"logo")} className="mjwi-catalog-logo" 
                        onError={(e) => {
                            if (!e.target.src.includes("Default-Widget-Logo.png")) {
                                e.target.onerror = null; 
                                e.target.src = "/images/Default-Widget-Logo.png";
                            }
                        }}
                        alt="Widget Logo"
                    />
                    <div className='mjwi-ct-card-container'>
                    <h3 className="mjwi-ct-card__title">
                    {widget.displayName || widget.name}
                    </h3>
                    <h3 className="mjwi-ct-card__title">
                    Price : ${widget.price}
                    </h3>
                    </div>
                    </div>
                    <div className="mjwi-ct-card-desc">
                    <p className="mjwi-ct-card__content">{widget.desc}</p>
                </div>
               </Link>
             ))}
          </div>
        </div>
        <div className={'mjwi-error' + (error ? '' : ' mjwi-hidden')}>{error}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return (
      {
          widgetTypes: state.widgetTypes,
      }
  )
}

export default connect(mapStateToProps,null )(Catalog);